<script>
import Layout from "@/layouts/main.vue";
import PageHeader from "@/components/page-header";

export default {
  components: {
    Layout,
    PageHeader
  },
  data() {
    return {
      data: {},
      permission: [],
      isBulkChecked: 0,
      filter: {
        keyword: ''
      },
    };
  },
  mounted() {
    var vm = this;

    vm.load();
  },
  watch: {
    $route() {
      var vm = this;

      vm.load();
    },
    isBulkChecked: function () {
      var vm = this;

      vm.bulkCheck();
    },
  },
  computed: {
    filteredPermissions: function () {
      var vm = this;

      vm.permission.forEach(function (item) {
        if (vm.data.permission.length > 0) {
          vm.data.permission.forEach(function (id) {
            if (item.id == id) {
              item.is_checked = 1;
            }
          });
        }
      });

      var keyword = vm.filter.keyword;
      var filtered = vm.permission;

      if (keyword) {
        filtered = filtered.filter(function (item) {
          return (item.name.toLowerCase().includes(keyword) || item.id.toString().includes(keyword)
            || item.label.toLowerCase().includes(keyword));
        });
      }

      return filtered;
    }
  },
  methods: {
    bulkCheck: function () {
      var vm = this;

      vm.filteredPermissions.forEach(function (item) {
        vm.permission.forEach(function (permission) {
          if (item.id == permission.id) {
            if (vm.isBulkChecked == 1) {
              permission.is_checked = 1;
            } else {
              permission.is_checked = 0;
            }
          }

        });
      });
    },
    load() {
      var vm = this;

      if (vm.$route.params.id) {
        vm.create();
      } else {
        vm.newData();
      }

      vm.fetchPermission();
    },
    newData() {
      var vm = this;

      var data = {
        id: null,
        name: null,
        permission: [],
      };

      vm.data = Object.assign({}, data);
    },
    async create() {
      var vm = this;

      this.$loading.on('permission_group_detail_create');
      try {
        vm.newData();

        var resp = await this.$api.PermissionGroup.get(vm.$route.params.id);
        var data = resp.data.data;

        vm.data = data;

        this.$loading.off('permission_group_detail_create');
      } catch (err) {
        this.$flash.error(err.response.data.message);
      }
    },
    async submit() {
      var vm = this;
      this.$loading.on('permission_group_detail_submit');

      try {
        var postData = vm._createPostData(vm.data);
        var resp = await this.$api.PermissionGroup.create(postData);

        var data = resp.data;

        vm.$ac.refresh();

        if (vm.$route.params.id) {
          vm.create();
        } else {
          vm.$router.push({ name: 'permission-group-detail', params: { id: data.data } });
        }

        this.$flash.success(data.message);
      } catch (err) {
        this.$flash.error(err.response.data.message);
      }
      this.$loading.off('permission_group_detail_submit');
    },
    _createPostData: function (data) {
      var vm = this;

      // clone the data
      var _data = Object.assign({}, data);

      _data.permission = [];

      vm.permission.forEach(function (item) {
        if (item.is_checked == 1) {
          _data.permission.push(item.id);
        }
      });

      delete _data.detail;

      return _data;
    },
    //============
    async fetchPermission() {
      var vm = this;

      this.$loading.on('permission_group_detail_permission_create');

      try {
        var params = {
          page: 'all',
          order_by: 'name',
          sort_by: 'asc'
        };

        var resp = await this.$api.Permission.all(params);
        var data = resp.data.data;

        var permission = vm.$_.map(data, function (row) {
          return { id: row.id, name: row.name, label: row.label, is_checked: 0 };
        });

        vm.permission = permission;

        vm.$loading.off('permission_group_detail_permission_create');
      } catch (err) {
        // console.log(err.response.data.message)
      }
    },
  }
};
</script>

<template>
  <Layout>
    <PageHeader :title="$t('permission_group.title.form')" :pageTitle="$t('menu.sub_header.dashboard')" />

    <BRow>
      <BCol lg="12">
        <BTabs variant="link" nav-class="nav-tabs-custom border-bottom-0">
          <BTab :title="$t('permission_group.tab.detail')" class="pt-2">
            <BRow class="justify-content-center">
              <BCol lg="12">
                <b-form @submit="submit()">
                  <BCard no-body>
                    <BCardBody>
                      <loading :loading="$loading.get('permission_group_detail_create')" variant="dark" type="block">
                        <BRow>
                          <BCol class="mb-3" lg="12">
                            <label class="form-label" for="product-title-input">{{ $t('permission_group.label.name')
                            }}</label>
                            <input type="text" class="form-control" v-model="data.name" id="product-title-input"
                              :placeholder="$t('permission_group.placeholder.name')" />
                          </BCol>
                        </BRow>
                      </loading>
                    </BCardBody>
                    <BCardFooter v-if="$ac.hasAccess('permission_group_create')">
                      <div class="hstack gap-2 justify-content-end">
                        <BButton type="submit" variant="success" class="w-sm"
                          v-if="($ac.hasAccess('permission_group_create'))"
                          :disabled="$loading.get('permission_group_detail_submit')">
                          <loading :loading="$loading.get('permission_group_detail_submit')" variant="light"
                            type="button">
                            <i class="mdi mdi-floppy me-1"></i>
                            {{ $t('basic.btn.save') }}
                          </loading>
                        </BButton>
                      </div>
                    </BCardFooter>
                  </BCard>
                </b-form>
              </BCol>
            </BRow>
          </BTab>
          <BTab :title="$t('permission_group.tab.permission')" class="pt-2" v-if="data.id">
            <loading
              :loading="$loading.get('permission_group_detail_create') || $loading.get('permission_group_detail_permission_create')"
              variant="dark" type="block">
              <BRow class="g-4 align-items-center mb-3">
                <BCol sm>
                  <div class="d-flex justify-content-sm-end">
                    <div class="search-box ms-2">
                      <input type="text" class="form-control" v-model="filter.keyword"
                        :placeholder="$t('filter.placeholder.keyword')" />
                      <i class="mdi mdi-magnify search-icon"></i>
                    </div>
                  </div>
                </BCol>
              </BRow>
              <BRow>
                <BCol lg="12">
                  <BCard no-body>
                    <BCardBody>
                      <div class="table-responsive table-card position-relative">
                        <table class="table align-middle table-hover table-nowrap mb-0">
                          <thead class="table-light">
                            <tr>
                              <th class="text-center" style="width: 10px;"
                                v-if="$ac.hasAccess('permission_group_create')">
                                <input v-model="isBulkChecked" type="checkbox" true-value="1" false-value="0">
                              </th>
                              <th>{{ $t('permission_group.label.key') }}</th>
                              <th>{{ $t('permission_group.label.name') }}</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr v-for="(tr, index) in filteredPermissions" :key="index" :class="{
                              'bg-success-subtle': tr.is_checked == 1,
                            }">
                              <td class="text-center" v-if="$ac.hasAccess('permission_group_create')">
                                <input true-value="1" false-value="0" v-model="tr.is_checked" type="checkbox">
                              </td>
                              <td>{{ tr.name }}</td>
                              <td>{{ tr.label }}</td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </BCardBody>
                  </BCard>
                </BCol>
              </BRow>
            </loading>
            <BRow>
              <BCol lg="12" class="mb-3" v-if="$ac.hasAccess('permission_group_create')">
                <b-form @submit="submit()">
                  <div class="hstack gap-2 justify-content-end">
                    <BButton type="submit" variant="success" class="w-sm"
                      v-if="($ac.hasAccess('permission_group_create'))"
                      :disabled="$loading.get('permission_group_detail_submit')">
                      <loading :loading="$loading.get('permission_group_detail_submit')" variant="light" type="button">
                        <i class="mdi mdi-floppy me-1"></i>
                        {{ $t('basic.btn.save') }}
                      </loading>
                    </BButton>
                  </div>
                </b-form>
              </BCol>
            </BRow>
          </BTab>
        </BTabs>
      </BCol>
    </BRow>
  </Layout>
</template>